import { Stack } from "@/core/components/ui/stack";
import { toast } from "@/core/components/ui/toast";
import { BusinessSettingsSidebarHeader } from "@/business-settings/common/business-settings-sidebar-header";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";
import { FilterableSpiffList } from "@/spiffs/common/filterable-spiff-list";
import { useSpiffSidebar } from "@/spiffs/context/spiff-sidebar-context";
import { useGetUserDismissedSpiffs, useReinstateSpiff } from "@/spiffs/query";
import { useGetBusinessUser } from "@/user/query";

interface DismissedSpiffsSidebarProps {
  userId: string;
  businessId?: string | null;
}

const SpiffPaymentsDismissedSidebar = ({
  userId,
  businessId,
}: DismissedSpiffsSidebarProps) => {
  const { resetSidebar } = useSpiffSidebar();
  const { data: user } = useGetBusinessUser(businessId, userId);
  const { data: dismissedSpiffs = [] } = useGetUserDismissedSpiffs(userId);
  const { mutate: reinstateSpiff } = useReinstateSpiff(businessId);

  const name =
    user?.first_name && user?.last_name
      ? `${user.first_name} ${user.last_name}`
      : user?.email || "Unknown User";

  const handleUndismissSpiff = (spiffId: string) => {
    reinstateSpiff(
      { spiffId: spiffId },
      {
        onSuccess: () => {
          toast.success("Spiff payout reinstated");
        },
        onError: (error) => {
          toast.error("Failed to reinstate spiff payout", {
            description: error.message,
          });
        },
      },
    );
  };

  return (
    <BusinessSettingsSidebarWrapper>
      <BusinessSettingsSidebarHeader
        headerText="Dismissed spiffs for"
        name={name}
        onClose={resetSidebar}
      />
      <Stack
        gap="none"
        fullWidth
        className="h-full min-h-0 flex-1 pl-6 pr-2 pt-4"
      >
        <FilterableSpiffList
          spiffs={dismissedSpiffs}
          onUndismissSpiff={handleUndismissSpiff}
          emptyMessage="No dismissed spiff payouts"
        />
      </Stack>
    </BusinessSettingsSidebarWrapper>
  );
};

export default SpiffPaymentsDismissedSidebar;
